<template>
    <div class="container">
		<div class="sidebar">
		  <my-component></my-component>
		</div>
		<div class="content" >
			
		<div class="page-header" >
	     存证详情</div>
    <div v-if="isTxHash" style="display: flex;">
	    
	    <div
		<form class="tx-form">
		  <div class="tx">
		    <div class="form-group">
		      <label for="tx-hash">存证哈希</label>
		      <span id="tx-hash">{{ txInfo.tx_hash }}</span>
		    </div>
		    <div class="form-group">
		      <label for="tx-status">存证状态</label>
		      <span id="tx-status">成功</span>
		    </div>
		    <div class="form-group">
		      <label for="tx-height">所在块</label>
		      <span id="tx-height">{{ txInfo.height }}</span>
		    </div>
		    <div class="form-group">
		      <label for="tx-time">时间</label>
		      <span id="tx-time">{{ txInfo.time }}</span>
		    </div>
		    <div class="form-group">
		      <label for="tx-gas">Gas(wanted/used)</label>
		      <span id="tx-gas">{{ txInfo.gas_wanted + "/" + txInfo.gas_used }}</span>
		    </div>
		      <div class="form-group">
		        <label for="action-type">类型</label>
		        <span id="action-type">地标存证</span>
		      </div>
		      <div class="form-group">
		        <label for="action-from">从</label>
		        <span id="action-from">{{ txInfo.from }}</span>
		      </div>
		      <div class="form-group">
		        <label for="action-to">到</label>
		        <span id="action-to">{{ txInfo.to }}</span>
		      </div>
		      <div class="form-group">
		        <label for="action-amount">存证积分</label>
		        <span id="action-amount">{{ JSON.stringify(txInfo.amount[0]) }}</span>
		      </div>
		      <div class="form-group">
		        <label for="action-certificate">数字证书</label>
		        <span id="action-certificate" @click="getValue">点击预览</span>
		      </div>
		      <!-- 注释掉的元素可以根据需要添加事件处理和样式 -->
		    </div>
		  </form>
		
		<!-- <div
		  class="tx_address"
		  v-else-if="
			txInfo.from == 'cosmos1s5sxcjgacyst5mx25j9cj4k0wuedku3mxsrn23' &&
			txInfo.memo.indexID== '1010002'
		  "
		>
		  <van-cell-group title="动作">
			<van-cell title="类型" value="存证上链" :border="false" />
			<van-cell title="从" :value="txInfo.from" :border="false" />
			<van-cell title="到" :value="txInfo.to" :border="false" />
			<van-cell
			  title="存证积分"
			  :value="JSON.stringify(txInfo.amount[0])"
			  :border="false"
			/>
			<van-cell
			  class="text"
			  title="素材信息"
			  :border="false"
			  @click="getPrice"
			  >点击详情(memo)</van-cell
			>
		  </van-cell-group>
		</div> -->
		<memo v-if="show" :isVisible="show" :memo="txInfo.memo"></memo>
		
	    <el-dialog
	       title="证书预览和下载"
	       :visible.sync="dialogVisible"
	       :before-close="handleClose"
	     >
	        <div id="pdfDom">
	            <component :is="certificateTemplate" :tx-info="txInfo"></component>
	            
				<div class="chapter" v-show="isShow">
				  <canvas id="chapterCanvas" width="150" height="150"></canvas>
				</div>	
				
	   
	       </div>
		   
		   <span slot="footer" class="dialog-footer">
		   				<el-switch
		   				  inactive-color="#67c23a"
		   				  v-model="downType"
		   				  active-text="图片下载"
		   				  inactive-text="pdf下载"
		   				  style="margin-right: 20px"
		   				>
		   				</el-switch>
		   				<el-checkbox v-model="isShow" style="margin-right: 20px"
		   				  >添加盖章</el-checkbox
		   				>
		   				<el-button @click="dialogVisible = false">取 消</el-button>
		   				<el-button type="primary" @click="getPdf('#pdfDom')">下载</el-button>
		   				<el-radio-group v-model="selectedCertificateTypeName">
		   				      <el-radio label="type1">类型1</el-radio>
		   				      <el-radio label="type2">类型2</el-radio>
		   				      <el-radio label="type3">类型3</el-radio>
		   				      <el-radio label="type4">类型4</el-radio>
		   				      <el-radio label="type5">类型5</el-radio>
		   				    </el-radio-group>
		   				
		   				      <el-button @click="certificateTypeDialogVisible = false">取消</el-button>
		   				      <el-button type="primary" @click="confirmCertificateType">确定</el-button>
		   				   
		   </span>
		   
	        </el-dialog>

	        </div>
	  <div v-else class="noBox">暂时未找到数据</div>
	   </div>
	   
	  
    </div>
	
	
    
  
</template>

<script>
import CertificateContent1 from '@/components/CertificateContent1.vue';
import CertificateContent2 from '@/components/CertificateContent2.vue';
import CertificateContent3 from '@/components/CertificateContent3.vue';
import CertificateContent4 from '@/components/CertificateContent4.vue';
import CertificateContent5 from '@/components/CertificateContent5.vue';
import MyComponent from '@/components/MyComponent.vue';
import Memo from "../components/Memo.vue";
export default {
  components: { Memo ,  MyComponent, CertificateContent1,CertificateContent2,CertificateContent3,CertificateContent4,CertificateContent5},
  data() {
    return {
      id: parseInt(new Date().getTime() / 1000) + "",
      dialogVisible: false,
	  selectedCertificateTypeName: "type1",
      pageData: null, //接收html格式代码
      htmlTitle: "确权证书",
      isShow: true,
	  certificateType: "type3",
      isCanvas: false,
      downType: true, // false为 pdf , true为图片
      show: false,
      currentPage: 1,
      pageSize: 10,
      txInfo: null,
      isTxHash: "",
      tableData: [],
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.reload();
      },
      immediate: true,
    },
  },
   computed: {
      certificateTemplate() {
        switch (this.certificateType) {
          case 'type1':
            return CertificateContent1;
          case 'type2':
            return CertificateContent2;
		  case 'type3':
		    return CertificateContent3;
		  case 'type4':
		    return CertificateContent4;
		  case 'type5':
		    return CertificateContent5;
          // 更多case...
          default:
            return null;
        }
      }
    },
  mounted() {},
  methods: {
	confirmCertificateType() {
	       
	       // 使用selectedCertificateTypeName更新certificateType
	       this.certificateType = this.selectedCertificateTypeName;
	       
	    }, 
    handleClose() {
      this.dialogVisible = false;
    },
    getPrice(val) {
      this.show = true;
    },
    getValue(){
	
      this.dialogVisible = true;
	  
      this.$nextTick(() => {
        if (!this.isCanvas) {
          // 只绘画一次
          this.isCanvas = true;
          this.getChapter();
        }
      });
    },
    getChapter() {
      var canvas = document.getElementById("chapterCanvas");
      var context = canvas.getContext("2d");

      var text = "xxx专用章";
      var companyName = "湖北省数权数据有限公司";
      //  context.translate(0, 0);
      // context.clearRect(0, 0, 200, 200);//清除整个画布
      // 绘制印章边框
      var width = canvas.width / 2;
      var height = canvas.height / 2;
      context.lineWidth = 3;
      context.strokeStyle = "#cf0c0c";
      context.beginPath();
      context.arc(width, height, 60, 0, Math.PI * 2); //宽、高、半径
      context.stroke();

      //画五角星
      create5star(context, width, height, 15, "#cf0c0c", 0);

      // 绘制印章名称
      context.font = "20px 宋体";
      context.textBaseline = "middle"; //设置文本的垂直对齐方式
      context.textAlign = "center"; //设置文本的水平对对齐方式
      context.lineWidth = 1;
      context.strokeStyle = "#cf0c0c";
      // context.strokeText(text, width, height + 30); // 名称 xx专用章

      // 绘制印章单位
      context.translate(width, height); // 平移到此位置,
      context.font = "20px 宋体";
      var count = companyName.length; // 字数
      var angle = (5 * Math.PI) / (3 * (count - 1)); // 字间角度
      var chars = companyName.split("");
      var c;
      for (var i = 0; i < count; i++) {
        c = chars[i]; // 需要绘制的字符
        if (i == 0) {
          context.rotate((4 * Math.PI) / 6); // 文字起始位置
        } else {
          context.rotate(angle);
        }

        context.save();
        context.translate(45, 0); // 平移到此位置,此时字和x轴垂直，公司名称和最外圈的距离
        context.rotate(Math.PI / 2); // 旋转90度,让字平行于x轴
        context.strokeText(c, 0, 0); // 此点为字的中心点
        context.restore();
      }

      //绘制五角星
      function create5star(context, sx, sy, radius, color, rotato) {
        context.save();
        context.fillStyle = color;
        context.translate(sx, sy); //移动坐标原点
        context.rotate(Math.PI + rotato); //旋转
        context.beginPath(); //创建路径
        var x = Math.sin(0);
        var y = Math.cos(0);
        var dig = (Math.PI / 5) * 4;
        for (var i = 0; i < 5; i++) {
          //画五角星的五条边
          var x = Math.sin(i * dig);
          var y = Math.cos(i * dig);
          context.lineTo(x * radius, y * radius);
        }
        context.closePath();
        context.stroke();
        context.fill();
        context.restore();
      }
    },
    reload() {
      if (this.$route.query.tx_hash) {
        this.getBlockTable(this.$route.query.tx_hash);
      } else {
        this.$notify({
          title: "提示",
          message: "浏览器网址不对",
          type: "warning",
          duration: 1000,
        });
      }
    },
    getPage(value) {},
    getBlockTable(tx_hash) {
      this.$http.get(`${block_ip}tx/${tx_hash}`).then((res) => {
        let data = res.data.data;
        if (data) {
          this.txInfo = data;
          this.tableData = data.txs;
          this.isTxHash = this.$route.query.tx_hash;
        } else {
          this.$notify({
            title: "提示",
            message: "传入区块哈希有误!",
            type: "warning",
            duration: 1000,
          });
        }
      });
    },
  },
};


</script>
<style lang="scss" scoped>
	.container {
	  display: flex;
	  min-height: 100vh;
	}
	
	.sidebar {
	 
	  height: 100vh; /* 侧边栏高度 */
	  
	}
	
	.content {
	 
	  width:800px;
	  padding: 20px; /* 内容区域的内边距 */
	  background-color: rgb(37,49,63);
	}
.text {
  .van-cell__value {
    color: blue;
  }
}
.block_txs {
  margin-top: 20px;
}
.mobile_cell {
  border: 1px solid #ebedf0;
  border-width: 1px 0;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
}
.van-cell__value {
  flex: 3;
}
.van-cell__value {
  text-align: left;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
}
.noBox {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin: 10px 12px;
}
.van-cell {
  padding: 10px 16px 10px 16px;
  background-color: black;
}

.tx_address,
.tx {
  margin: 0 12px;
  background-color: #fff;
}

.tx_address {
  margin-top: 30px !important;
  margin: 0 12px;
  background-color: #fff;
}
.pagination {
  margin: 0 12px;
}
.van-cell-group__title {
  padding: 8px 0 8px;
  font-size: 16px;
}
.van-cell__title {
  flex: 2;
}
::v-deep .el-dialog__body {
  padding: 0px;
}
::v-deep .el-dialog__footer {
  background-color: white;
}
::v-deep .el-dialog {
	height:1080px;
  width: 750px;
  margin-top: 60px !important;
}
#pdfDom {
  /* 要想pdf周边留白，要在这里设置 */
  width: 750px;
}
.proBox {
  background: url("../assets/OIP-C.jpg") no-repeat;
  background-size: cover;
  width: 750px;
  height:1080px;
  padding: 90px 94px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
 
  font-family: SimSun;
}
.tit {
  color: rgb(42,111,176);
  font-size: 28px;
  font-weight: 700;
  position: relative;
  text-align: center;
  top: -6px;
  left: 8px;
  letter-spacing: 20px;
  font-family: STHeiti;
  margin-top:110px;
  margin-bottom:-5px;
}
.proid {
  font-weight: 500;
  padding:25px;
   color: rgb(42,111,176);
  /* margin-right: 5px; */
}
.con {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  margin: 10px 0;
  line-height: 32px;
  text-indent: 2em;
}
.con-name {
  font-family: 华文行楷, STXingkai;
  border-bottom: 2px solid #000;
}
.con-unit {
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  right: 100px;
  bottom: 100px;
  text-align: center;
  letter-spacing: 3px;
}
.con-unit p {
  margin: 5px 0;
}
.con-footer {
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  bottom: 45px;
  left: 0;
  right: 0;
  text-align: center;
}
.chapter {
  border-radius: 50%;
  position: absolute;
  bottom: 75px;
  right: 134px;
}
/* 添加一些基本的样式 */
.el-radio-group {
  margin: 15px 0; /* 外边距，根据需要调整 */
}

/* 为每个el-radio添加样式 */
.el-radio {
  margin-right: 15px; /* 右侧外边距，使按钮之间有间隔 */
  font-size: 14px; /* 字体大小 */
}

/* 可以为选中状态的单选按钮添加特殊样式 */
.el-radio__inner {
  border-color: #409eff; /* 边框颜色 */
  background-color: #409eff; /* 选中时的背景颜色 */
}

/* 选中时的字色 */
.el-radio__inner::after {
  background-color: #fff; /* 选中时的填充颜色 */
}

/* 为label添加样式 */
.el-radio__label {
  color: #606266; /* 字体颜色 */
}

/* 悬停效果 */
.el-radio:hover .el-radio__inner {
  border-color: #909399; /* 鼠标悬停时的边框颜色 */
}
.van-cell {
		background-color: rgb(26,35,45);
		color:white;
		
	}
	.tx-form {
	  font-family: Arial, sans-serif;
	  margin: 20px;
	  padding: 20px;
	  border: 1px solid #ccc;
	  border-radius: 5px;
	  background-color: #f9f9f9;
	  width:700px;
	}
	
	.form-group {
	  margin-bottom: 15px;
	}
	
	.form-group label {
	  display: block;
	  font-weight: bold;
	  margin-bottom: 5px;
	}
	
	.form-group span {
	  display: block;
	  padding: 5px;
	  border: 1px solid #ddd;
	  border-radius: 3px;
	  background-color: #fff;
	}
	
	/* 可以添加一些响应式设计 */
	@media (max-width: 600px) {
	  .form-group label,
	  .form-group span {
	    display: block;
	    width: 100%;
	  }
	}
	.action-form {
	  font-family: Arial, sans-serif;
	  margin: 20px;
	  padding: 20px;
	  border: 1px solid #ccc;
	  border-radius: 5px;
	  background-color: #f9f9f9;
	  width:700px;
	}
	
	.action-group {
	  margin-bottom: 15px;
	}
	
	.form-group {
	  margin-bottom: 10px;
	}
	
	.form-group label {
	  display: block;
	  font-weight: bold;
	  margin-bottom: 5px;
	}
	
	.form-group span {
	  display: block;
	  padding: 5px;
	  border: 1px solid #ddd;
	  border-radius: 3px;
	  background-color: #fff;
	  cursor: pointer; /* 当span可点击时 */
	  user-select: none; /* 防止用户选择文本 */
	}
	
	/* 为可点击的span添加样式 */
	.form-group span[clickable] {
	  color: blue;
	  text-decoration: underline;
	}
	
	/* 响应式设计 */
	@media (max-width: 600px) {
	  .form-group label,
	  .form-group span {
	    display: block;
	    width: 100%;
	  }
	}
	.page-header {
	  padding: 15px; /* 根据需要调整内边距 */
	  background-color: rgb(37,49,63); /* 背景颜色 */
	  position: relative; /* 相对定位，如果需要定位子元素 */
	  font-size:23px;
	  color:white;
	  font-weight:bold;
	
	   
	} 

	
	/* 标题美化 */
	.tit {
	  font-size: 42px; /* 更大的字体 */
	  font-weight: bold;
	  color: rgb(38,113,164); /* 更深的文字颜色 */
	  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); /* 文字阴影 */
	}
	
	/* 信息项美化 */
	.proid {
	  font-size: 20px; /* 更大的字体 */
	 font-weight: bold;
	  border-bottom: 1px solid #eee; /* 下边框 */
	  padding-bottom: 5px; /* 下边距 */
	  margin-bottom: 10px; /* 下边距 */
	}
	
	/* 按钮美化 */
	.el-button {
	  border-radius: 20px; /* 圆角按钮 */
	  padding: 10px 20px; /* 按钮内边距 */
	  font-size: 16px; /* 字体大小 */
	  transition: background-color 0.3s; /* 背景色变化动画 */
	}
	
	.el-button:hover {
	  background-color: #409eff; /* 鼠标悬浮时的背景色 */
	  color: white; /* 文字颜色 */
	}
	
	/* 下载选项美化 */
	.el-switch {
	  margin-bottom: 10px; /* 下边距 */
	}
	
	/* 盖章效果美化 */
	.chapter canvas {
	  border-radius: 50%; /* 圆形盖章 */
	  border: 2px solid #cf0c0c; /* 盖章边框 */
	}
	.title-underline {
	  border: none; /* 移除默认边框 */
	  height: 2px; /* 设置横线厚度 */
	  background-color: rgb(38,113,164); /* 设置横线颜色 */
	  width: 450px; /* 设置横线宽度 */
	  margin-bottom:20px;
	}
</style>
